import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventionsViewComponent } from '../../general/inventions-view/inventions-view.component';
import { InnovationActivityComponent } from '../../general/innovation-activity/innovation-activity.component';

export interface CompanyPopupData {
  company: any;
  theme: string;
  tabId: string;
  query: string;
}

@Component({
  selector: 'app-company-popup',
  standalone: true,
  imports: [CommonModule, InventionsViewComponent, InnovationActivityComponent],
  templateUrl: './company-popup.component.html',
  styleUrl: './company-popup.component.css'
})
export class CompanyPopupComponent implements OnInit {
  showInventions: boolean = false;
  refreshKey: number = 0; // Used to force component refresh

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: CompanyPopupData,
    private dialogRef: MatDialogRef<CompanyPopupComponent>
  ) {}

  ngOnInit(): void {
    this.showInventions = false; // Start with activity view
  }

  showInventionsView(): void {
    this.showInventions = true;
    this.refreshKey++; // Force refresh of inventions component
  }

  showActivityView(): void {
    this.showInventions = false;
    this.refreshKey++; // Force refresh of activity component
  }

  closePopup(): void {
    this.dialogRef.close();
  }
}
